import { usePostHog } from 'posthog-js/react';
import { useCallback } from 'react';
import { ROUTE_DASHBOARD } from '../components/trashie/config/routes';
import { getEventName, POSTHOG_PROPERTIES, TRACKER_IDS } from '../components/trashie/config/tracker';
import useInactivityTimer from './useInactivityTimer';
import useNavigateWithSearch from './useNavigateWithSearch';

const useRedirectWithPostHog = (storeConfig) => {
  const navigateWithSearch = useNavigateWithSearch();
  const posthog = usePostHog();

  //------------------------------------------
  // Redirect to earnings
  //------------------------------------------

  const redirectToEarnings = useCallback((autoRedirect) => {
    posthog.capture(
      getEventName(TRACKER_IDS.tbb.lastStep.redirect),
      {
        [POSTHOG_PROPERTIES.TBB_AUTO_REDIRECT]: autoRedirect,
      },
    );

    navigateWithSearch(ROUTE_DASHBOARD);
  }, [navigateWithSearch]);

  //------------------------------------------
  // Inactivity timer Hook
  //------------------------------------------

  const { waitTimer } = useInactivityTimer(
    !storeConfig?.registerTbbFlow?.isAuthFreeFlow,
    () => redirectToEarnings(true),
  );

  //------------------------------------------
  // Return values
  //------------------------------------------

  return { waitTimer, redirectToEarnings };
};

export default useRedirectWithPostHog;
